// Every external (employer) link the app opens goes through here: the scheme is re-checked on the
// client (defence in depth for rows stored before the server-side check existed) and the new tab
// gets no opener (reverse tabnabbing).
import { isSafeHttpUrl } from "@jobreel/shared";

export function openExternal(url: string | null | undefined, win: Pick<Window, "open"> = window): boolean {
  if (!isSafeHttpUrl(url)) return false;
  win.open(url.trim(), "_blank", "noopener,noreferrer");
  return true;
}
